import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import {getManager} from "../../../ts/manager/Manager";
import RouteModel from "../../../ts/model-factory/basic/route/RouteModel";
import CardDeckView from "../snippet/CardDeckView";

interface IProps
{
    routeProps: IRouteProps
    routeModel?:RouteModel|null
    includeIDs?:string[];
    excludeIDs?:string[];
    title?:string;
}

const NavRelatedPagesView = (props: IProps) =>
{
    const routeProps = props.routeProps;
    const routeChoice = routeProps.choice;
    let routeChoiceList:RouteChoice[] = [];
    if(props.routeModel) {
        const fromChoiceList = props.routeModel.choiceList();
        for(let altChoice of fromChoiceList){
            if((altChoice.navigationRouteKey !== routeChoice.navigationRouteKey) || (altChoice.id !== routeChoice.id)){
                routeChoiceList.push(altChoice);
            }
        }
    } else {
        let choiceFound = false;
        for(let level of getManager().navigation.model.levelList){
            if(choiceFound){
                const fromChoiceList = level.model.choiceList();
                if(fromChoiceList.length){
                    routeChoiceList = fromChoiceList;
                }
                break;
            }
            if(level.factoryID === routeChoice.factoryID){
                if(level.choiceID !== routeChoice.id){
                    break;
                }
                choiceFound = true;
                const fromChoiceList = level.model.choiceList();
                for(let altChoice of fromChoiceList){
                    if(altChoice.id !== routeChoice.id){
                        routeChoiceList.push(altChoice);
                    }
                }
            }
        }
    }
    for(let i = 0; i < routeChoiceList.length; i++){
        let valid = true;
        if(props.includeIDs && !props.includeIDs.includes(routeChoice.id)){
            valid = false
        } else if(props.excludeIDs && props.excludeIDs.includes(routeChoice.id)){
            valid = false
        }
        if(!valid){
            routeChoiceList.splice(i, 1);
            i --;
        }
    }
    if(!routeChoiceList.length){
        return <></>
    }

    const isSlick = routeChoiceList.length > 2;
    return <section className="content-block set-bg-grey">
        <div className="container">
            {props.title && <>
                <div className="row mb-4">
                    <div className="col-12">
                        <h2 className="block-title">{props.title}</h2>
                    </div>
                </div>
            </>}
            <CardDeckView
                routeChoiceList={routeChoiceList}
                isSlick={isSlick}
                removeData={true}
                desktopCols={3}
                useID="relatedPostsTicker"
            />

        </div>
    </section>
}
export default NavRelatedPagesView;